import React from 'react';
import { node } from 'prop-types';

import styles from './CampaignLayout.scss';

const CampaignLayout = ({ children }) => (
  <div className={styles.root}>{children}</div>
);

CampaignLayout.propTypes = {
  children: node.isRequired,
};

export default CampaignLayout;



// WEBPACK FOOTER //
// ./app/layouts/CampaignLayout/CampaignLayout.jsx